export default __webpack_public_path__ + "img/trash.9c97b5f.svg";